<nav class="navbar navbar-dark navbar-expand fixed-top bg-dark flex-md-nowrap shadow">
  <a class="navbar-brand col-sm-1 col-md-1 mr-auto" href="/">
    <img src="assets/img/tripodti.png" aria-label="tripod: Tecnologias de Informação"
      title="tripod: Tecnologias de Informação">
  </a>

  <ul class="navbar-nav mx-auto">
    <li class="nav-item text-nowrap" *ngIf="user">
      <mat-icon *ngIf="showIcon">person_outline</mat-icon>
      <span *ngIf="!showIcon" class="emoji {{emojiCssClass}}">{{emoji}} </span>{{user.username}}
    </li>
  </ul>

  <ul class="navbar-nav ml-auto">
    <li class="nav-item text-nowrap">
      <a class="nav-link" (click)="logout()" href="">
        <mat-icon>logout</mat-icon>
        Sair
      </a>
    </li>
  </ul>
</nav>
